import { EventEmitter } from '@angular/core';
import { UrlService } from './common/url.service';
import { TranslateService } from '@ngx-translate/core';
/**
 * Service for Header functionality
 */
var HeaderService = /** @class */ (function () {
    function HeaderService(urlService, translateService) {
        this.urlService = urlService;
        this.translateService = translateService;
        this.duoUrl = 'https://www.deutsch-uni.com/';
        this.showHeaderChanged = new EventEmitter();
        this.showLoginChanged = new EventEmitter();
    }
    HeaderService.prototype.showHeader = function (showHeader) {
        return this.showHeaderChanged.emit(showHeader);
    };
    HeaderService.prototype.showLogin = function (showLogin) {
        return this.showLoginChanged.emit(showLogin);
    };
    // tslint:disable:max-line-length
    HeaderService.prototype.generateMenu = function () {
        var menuList = new Array();
        menuList.push({
            menuName: 'MENU_LINK.LEARN_WITH_DUO',
            href: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.LEARNING_WITH_DUO') + "/",
            isActive: false, useTranslation: true
        });
        menuList.push({
            menuName: 'MENU_LINK.GERMAN_COURSE',
            href: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.GERMAN_COURSE') + "/",
            isActive: true, useTranslation: true
        });
        menuList.push({
            menuName: 'MENU_LINK.INSTITUTIONS',
            href: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.INSTITUTIONS') + "/",
            isActive: false, useTranslation: true
        });
        menuList.push({
            menuName: 'MENU_LINK.ABOUT_DUO',
            href: "" + this.duoUrl + this.translateService.currentLang + "/" + this.translateService.instant('GAST-PORTAL-NG.DUO-URL.ABOUT_DUO') + "/",
            isActive: false, useTranslation: true
        });
        return menuList;
    };
    return HeaderService;
}());
export { HeaderService };
